/**
 * LazyLoading & Intersection Observer
 */

import lozad from 'lozad'

// Images
const simpleLazyImgs = document.querySelectorAll('.lazy-image img');
const defaultObserver = lozad(simpleLazyImgs, {
  threshold: 0,
  loaded: function(el) {
    el.removeAttribute('data-src');
    el.removeAttribute('data-srcset');
  }
});
defaultObserver.observe();

for (const simpleLazyImg of simpleLazyImgs) {
  if (!simpleLazyImg.getAttribute('data-background-image')) {
    simpleLazyImg.onload = function() {
      this.setAttribute('data-fully-loaded', true);
    };
  }
}

const revealImgsContainer = document.querySelectorAll('.reveal-lazy-image');
const revealImgs = document.querySelectorAll('.reveal-lazy-image img');

if(revealImgsContainer.length) {
  const revealImgObserver = lozad(revealImgs, {
    threshold: 0.2,
    load: function(el) {
      el.parentNode.classList.add('reveal-me');
    },
    loaded: function(el) {
      el.src = el.getAttribute('data-src');
    }
  });
  revealImgObserver.observe();

  for (const revealImg of revealImgs) {
    if (!revealImg.getAttribute('data-background-image')) {
      revealImg.onload = function() {
        this.setAttribute('data-fully-loaded', true);
      };
    }
  }
}


// Sections
const sectionsObserver = lozad('[data-animated]', {
  rootMargin: '30px 0px'
});

sectionsObserver.observe();
